const userHasRole = (user, roleToFind) => {
    return user.roles.some((role) => role.name === roleToFind);
};
export default userHasRole;
